import React from "react";
import { Outlet } from "react-router-dom";

function AccountLayout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default AccountLayout;
